export default __webpack_public_path__ + "static/media/snack-3.d9b4ee2d.jpg";